import React from 'react';

export default function CustomSwitch(props) {
  const { val, handleChange, disabled, dataAttributes } = props;
  return (
    <div
      className={`custom-switch-wrapper ${val === true ? 'yes' : 'no'} ${
        disabled ? 'disabled' : ''
      }`}
      onClick={() => !disabled && handleChange()}
      {...dataAttributes}
    >
      {val === true ? (
        <>
          Yes <span></span>
        </>
      ) : (
        <>
          <span></span>No
        </>
      )}
    </div>
  );
}
